import emailCheck from './emailFormatCheck';
const CHECK_PASSWORD_PATTERN = /.{8,36}/;

class Validator {
  target;
  errorMessages = [];
  errorState = {};
  constructor(target) {
    this.target = target;
  }

  getErrorMessage() {
    return this.errorMessages;
  }

  getErrorState() {
    return this.errorState;
  }

  getFirstErrorMessage() {
    return this.haveError() && this.errorMessages[0];
  }

  haveError() {
    return Object.keys(this.errorState).length > 0;
  }

  isEmpty(msg) {
    if (!this.target) {
      this.errorState.empty = true;
      this.errorMessages.push(msg);
    }

    return this;
  }

  isMatchWith(compare, msg) {
    if (this.target !== compare) {
      this.errorState.mathWith = true;
      this.errorMessages.push(msg);
    }

    return this;
  }

  minLength(length = 1, msg) {
    if (this.errorState.empty || this.target.length < length) {
      this.errorState.minLength = true;
      this.errorMessages.push(msg);
    }

    return this;
  }

  maxLength(length, msg) {
    if (this.errorState.empty || this.target.length > length) {
      this.errorState.maxLength = true;
      this.errorMessages.push(msg);
    }

    return this;
  }

  isEmail(msg) {
    if (this.errorState.empty || !emailCheck.test(this.target)) {
      this.errorState.email = true;
      this.errorMessages.push(msg);
    }

    return this;
  }

  isPassword(msg) {
    if (this.errorState.empty || !CHECK_PASSWORD_PATTERN.test(this.target)) {
      this.errorState.password = true;
      this.errorMessages.push(msg);
    }

    return this;
  }

  isMatchNameRule(msg) {
    if (emailCheck.test(this.target)) {
      this.errorState.tutorName = true;
      this.errorMessages.push(msg);
    }

    return this;
  }
}

export default Validator;



// WEBPACK FOOTER //
// ./app/utils/validator.js